// extracted by mini-css-extract-plugin
export default {"manageAdmin":"manageAdmin_manageAdmin__WQLXr"};